import React, { useContext } from 'react'
import TodoContext from '../todoCtx/TdoCtx';
import "././students.css"

import {getClass8Record, setClass8Record} from "../../services/class8Record.service"
import {getClass9Record, setClass9Record} from "../../services/class9Record.service"
import EditForm from '../editForm/EditForm';

const StudentsSepa = () => {

    const {dblListItems, setDblListItems, showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa, compTodosMove1, showRecycleBin,setShowRecycleBin, showForm, setShowForm, students, showStudents,showClass8, setShowClass8, storedId, setStoredId, setShowStudents,setShowDblListSepa,showStudentsSepa, setShowStudentsSepa, studentsSepa, setStudentsSepa, studentClass, studentName, formData, setStudents, setStudentName,setStudentClass,studentsSepaForm, showEditForm, setShowEditForm,studentNameNew, setStudentNameNew, class8,setClass8, class9,setClass9, studentEmail, setstudentEmail, studentNumber, setstudentNumber} = useContext(TodoContext);

    const handleDelete = (event, id) => 

    {
  
        const newStudentsSepa = studentsSepa.filter(student => { 
          return student.id !== id}); 
        setStudentsSepa(newStudentsSepa);

        const newStudents = students.filter(student => { 
          return student.id !== id}); 
        setStudents(newStudents);
  
        const newClass8 = class8.filter(student => { 
          return student.id !== id}); 
        setClass8(newClass8);

        const newClass9 = class9.filter(student => { 
          return student.id !== id});         
        setClass9(newClass9);

        const newDblListItemsSepa = dblListItemsSepa.filter(student => { 
          return student.id !== id});
        setDblListItemsSepa(newDblListItemsSepa);

        // setShowDblList(true);
        setShowStudents(false);
        setShowStudentsSepa(false);

        
    }

    const handleEdit = (event, id)=> {

      console.log("edited")

      const itemFound=students.find((student)=>{
        return student.id === id
      });
        console.log("item found:",itemFound);


          if ( itemFound ) {

            console.log("if block")

            setShowEditForm(true);

            const sepaStudent = dblListItemsSepa.find(dblListItemSepa => { 
              return dblListItemSepa.id === id}); 

              console.log("sepaStudent", sepaStudent);

              const studentSepaStd = studentsSepa.find(studentSepa => { 
                return studentSepa.id === id}); 

              const name = studentSepaStd.fullName;

              const classStd = studentSepaStd.class;

              const emailStd = studentSepaStd.email;

              const numberStd = studentSepaStd.number;

              console.log("name", name);
              console.log("classStd", classStd);

              setStudentNameNew(name);
              setstudentEmail(emailStd);
              setstudentNumber(numberStd);
              setStudentClass(classStd);

              setShowClass8(showClass8 => !showClass8);

            // setStudentsSepaForm(sepaStudent);

            console.log("studentsSepaForm",studentsSepaForm);

            // setShowForm(true);

            setStoredId(id);

            setShowStudentsSepa(false);

          }

          else{

            console.log("hello edit");

          }

        const newStudents = [{ fullName : formData.fullName, email : formData.email, number : formData.number, class : studentClass, id: storedId  }, ...students ];

        const newStudentSingle = [{ fullName : formData.fullName, email : formData.email, number : formData.number, class : formData.class, id: storedId  }];

        const newStudentSingleDb = { fullName : formData.fullName, email : formData.email, number : formData.number,  class : studentClass, id: storedId  };

        
    
    
        // setStudentsSepa(newStudentSingle);

        setShowStudentsSepa(true);

        setShowStudents(false);


        // setStudents(newStudents);


        console.log("newStudentSingleDb",newStudentSingleDb);

        studentClass === "8" ? setClass8Record(newStudentSingleDb.id, newStudentSingleDb) : setClass9Record(newStudentSingleDb.id, newStudentSingleDb);

        // setStudentsSepa("");

        console.log("studentClass", studentClass);


    }


  return (
    <>
    {showEditForm && <EditForm/>}
    
    <div className='studentsContainerSepa'>
        
<ul>
        {studentsSepa && studentsSepa.map((student,index)=>(
      
        <li key={index} className="fullNameWrapper" > 
          
        
       <h4 className='fullName'>Full Name: {student.fullName} </h4>
       <h4 className='fullName'>Email: {student.email} </h4>
       <h4 className='fullName'>Phone Number: {student.number} </h4>
       <h4 className='fullName'>Class: {student.class} </h4>
       {/* <h4 className='fullName'>Id: {student.id} </h4> */}

       <div className='btnsConatiner'>

       <button className='editBtn' type='button' onClick={(event)=> {handleEdit(event, student.id)}}>Edit</button>
       <button className='dltBtn' type='button' onClick={(event)=> {handleDelete(event, student.id)}}>Delete</button>

       </div>

</li>
))

        }

</ul>
        
    </div>
    </>
  )
}

export default StudentsSepa